var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"es-form-section",style:([_vm.padding, _vm.margin])},[_vm._t("es-form-header"),_vm._t("es-form")],2)}
var staticRenderFns = []

export { render, staticRenderFns }